import styles from './Home.module.css';

import { useT, type MessageKey } from '@/i18n';
import { AppGlyph, AppIcon } from './AppIcons';
import { Button } from './Button';
import { ErrorNote } from './ErrorNote';
import type { IntroPanelProps } from './IntroPanel.types';

const INTRO: Record<'chat' | 'receive', MessageKey> = {
  chat: 'introPanel.chat',
  receive: 'introPanel.receive',
};

/** The panels of a secure chat and of receiving here: a sentence about what happens and one button. */
export function IntroPanel({ kind, head, error, canCreate, options, onCreate }: IntroPanelProps): React.JSX.Element {
  const t = useT();
  return (
    <div>
      {head}
      <div className={styles.intro}>
        <AppIcon kind={kind} className={styles.introIcon} />
        <p className={styles.introText}>{t(INTRO[kind])}</p>
      </div>
      {error ? <ErrorNote notice={error} /> : null}
      <div className={kind === 'chat' ? [styles.actions, styles.formFoot].join(' ') : styles.actions}>
        <Button type="button" className={styles.createBtn} icon={<AppGlyph kind={kind} size={19} />} disabled={!canCreate} onClick={onCreate} data-testid={kind === 'chat' ? 'create' : 'receive'}>
          {kind === 'chat' ? t('introPanel.openChat') : t('introPanel.receiveHere')}
        </Button>
        {options}
      </div>
    </div>
  );
}
